// extracted by mini-css-extract-plugin
export default {"tooltip":"oT-z","arrow":"pT-z"};